import React from 'react';

import {
  QuestionComponent,
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';

import {TextHighlightInputArea, TextHighlightExplanation} from './V2';

import './text-highlight-question.scss';

const TextHighlightQuestionComponent = (props: QuestionComponentProps) => {
  const {activeQuestion, activeQuestionStore} = props;
  return (
    <QuestionComponent
      {...props}
      activeQuestionStore={activeQuestionStore}
      customExplanation={
        <TextHighlightExplanation
          question={activeQuestion}
          activeQuestionStore={activeQuestionStore}
          storeName={activeQuestionStore.getName()}
        />
      }
      ActiveQuestionInputArea={TextHighlightInputArea}
    />
  );
};

type TextHighlightQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const TextHighlightQuestion = {
  PreGuess: (props: TextHighlightQuestionTypeProps) => (
    <TextHighlightQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: TextHighlightQuestionTypeProps) => (
    <TextHighlightQuestionComponent {...props} questionState='PostGuess' />
  ),
  Dennis: (props: TextHighlightQuestionTypeProps) => (
    <TextHighlightQuestionComponent {...props} questionState='Dennis' />
  )
};

export {TextHighlightQuestion};
